import React, { useState, useEffect } from "react";
import { useAuth } from "../AuthContext";
import Modal from "./ui/Modal";
import Button from "./ui/Button";
import TextInput from "./ui/TextInput";

const ProfileDialog = ({ open, onClose, onProfileUpdate, loading }) => {
  const { user } = useAuth();
  const [profileData, setProfileData] = useState({
    username: "",
    email: "",
  });

  // Initialize form data when dialog opens
  useEffect(() => {
    if (open && user) {
      setProfileData({
        username: user.username || "",
        email: user.email || "",
      });
    }
  }, [open, user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (onProfileUpdate) {
      await onProfileUpdate(profileData);
      if (!loading) {
        onClose();
      }
    }
  };

  const handleClose = () => {
    // Reset form data when closing
    setProfileData({
      username: user?.username || "",
      email: user?.email || "",
    });
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      panelClassName="w-full max-w-md rounded-2xl border-2 border-brand-purple/40 bg-surface-card/95 backdrop-blur-xl shadow-card"
    >
      <div className="flex items-center justify-between px-6 pt-6 pb-2">
        <h3 className="flex items-center gap-2 text-xl font-heading font-bold text-brand-purple">
          <span className="text-2xl">👤</span>
          Update Profile
        </h3>
        <button
          type="button"
          onClick={handleClose}
          aria-label="Close"
          className="h-8 w-8 rounded-full flex items-center justify-center text-white/60 hover:text-white hover:bg-white/10 transition-colors"
        >
          ✕
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="px-6 pb-2 space-y-4">
          <TextInput
            label="Username"
            icon="👤"
            value={profileData.username}
            onChange={(e) =>
              setProfileData((prev) => ({ ...prev, username: e.target.value }))
            }
          />
          <TextInput
            label="Email"
            icon="📧"
            type="email"
            value={profileData.email || user?.email || ""}
            readOnly
            className="opacity-80"
          />
          <p className="text-white/50 text-xs">
            Email changes are not currently supported. Contact support if
            needed.
          </p>
        </div>

        <div className="flex justify-end gap-3 px-6 pb-6 pt-4">
          <Button type="button" variant="outline" onClick={handleClose}>
            Cancel
          </Button>
          <Button type="submit" variant="primary" disabled={loading}>
            {loading ? "Updating..." : "Update Profile"}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default ProfileDialog;
